export default __webpack_public_path__ + "static/media/blogdoceapego.8ce3476a.jpg";